<template>
    <div class="proOption">

        <div class="amount">
            <span>最低提成</span>
            <el-input v-model="lowest_rate" style="width:150px;margin-left: 14px"></el-input>
        </div>
        <div class="amount">
            <span>最低卖价</span>
            <el-input v-model="lowest_price" style="width: 150px;margin-left: 14px"></el-input>
        </div>
        <div class="amount">
            <span>超过买家提成比率</span>
            <el-input v-model="beyond_rate" style="width: 150px;margin-left: 14px"></el-input>
        </div>
        <div class="footer">
            <el-button  type="primary" @click="updateGoodRate" :loading="btnLoading">确定
            </el-button>
            <el-button @click="$emit('update:visible', false)">取消</el-button>
        </div>
    </div>
</template>

<script>
    import { getPrice, addCartProducts, addorderList, setGoodsRate } from '../../stores/api';

    export default {
        //type 1:dialog, 2:popover
        props: ['type', 'list', 'visible', 'goods_id', 'getCartProducts', 'rec_id', 'qtyRaw','fang','lowest_price','lowest_rate','beyond_rate','getProducts'],
        data () {
            return {
                btnLoading: false,
                price: 0,
                repertory: 1,
                qty: 1,
                attr_list: this.list || []
            };
        },
        beforeMount () {
            console.log("list",this.attr_list);
            this.getPrice();
        },
        // mounted(){
        //     this.fang()
        // },
        methods: {
            handleChoose (index, id) {
                // console.log(id)
                if (this.attr_list[index].currId !== id) {
                    this.attr_list[index].currId = id;
                    this.getPrice();
                }
            },
            updateGoodRate () {
                this.lowest_price=Number(this.lowest_price)
                this.lowest_rate=Number(this.lowest_rate)
                this.beyond_rate=Number(this.beyond_rate)
                if(this.lowest_rate<0||this.lowest_rate>1){
                    this.$message.error('最低提成范围0~1')
                }else if(this.beyond_rate<0||this.beyond_rate>1){
                    this.$message.error('超过买家提成比率范围0~1')
                }else{
                    setGoodsRate(this.goods_id,this.lowest_rate,this.lowest_price,this.beyond_rate).then(res=>{
                        if(res.data.error==0){
                            this.$message.success("修改成功")
                            this.$emit('getProducts')
                            this.$router.push({path:'/GoodsSetup'})
                        }
                    })
                }
                // else if(!0<=this.beyond_rate<=1){
                //     this.$message.error('超过买家提成比率不能大于1')
                // }
                // setGoodsRate(this.goods_id,this.lowest_rate,this.lowest_price,this.beyond_rate).then(res=>{
                //     this.$message.success("修改成功")
                //     $emit('update:visible', false)
                // })
            },
            getPrice () {
                let attr = '';
                this.attr_list.forEach(item => {
                    attr += item.currId + ',';
                });
                getPrice({id: this.goods_id, attr}).then(res => {
                    // console.log(this.goods_id)
                    this.price = Number(res.data.result_no);
                    this.repertory = Number(res.data.product_number);
                });
            }
        },
        watch: {
            list (val) {
                this.attr_list = val || [];
                this.getPrice();
            },
        }
    };
</script>

<style lang="less" scoped>
    @import "../../default";

    .proOption {
        .btnGroup {
            display: flex;
            margin-bottom: 12px;
            & > span {
                flex: 0.2;
                line-height: 2;
                font-size: 14px;
            }
            .el-button-group {
                flex: 0.8;
                button {
                    min-width: 75px;
                    height: 30px;
                    margin-right: 8px;
                    margin-bottom: 8px;
                    padding: 0 10px;
                    background: #ffffff;
                    border-radius: 0;
                    border: 1px solid #dfe4ed;
                    font-size: 14px;
                    color: #1f2329;
                    &:hover {
                        .chosen;
                    }
                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 8px;
                        vertical-align: middle;
                    }
                }
                .chosen {
                    border-color: @orange;
                }
            }
        }
        .amount {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            & > span:nth-child(1) {
                flex: 0.5;
                line-height: 2;
            }
            & > span:nth-child(2) {
                flex: 0.8;
                color: #9ca2ad;
                text-align: left;
                /deep/ .el-input-number {
                    width: 75px;
                    .el-input-number__increase, .el-input-number__decrease {
                        width: 20px;
                    }
                    .el-input input {
                        color: @font_black;
                        padding: 0 30px 0 10px;
                        border-radius: 0;
                    }
                }
                & > span {
                    margin-left: 16px;
                }
            }
        }
        .footer {
            margin-top: 20px;
            margin-left: 160px;
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/Common/GoodsDs.vue